<template>
    <v-stepper v-model="step" style="width:100%">
        <loading-component :value="loading"></loading-component>
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Review And Update Time</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Select Captain & Dispatch Type</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">Saved!</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
            <v-stepper-content step="1">
                <requests-editor :requests="selectedItems" @updateStepper="updateStepper"/>
            </v-stepper-content>
            <v-stepper-content step="2">
                <v-layout row wrap>
                    <choose-captains-multi style="width:100%"
                                           v-model="captain"
                                           return-object
                                           :multi="false"
                                           :initial-search-params="captainSearchParams"
                                           label="Select Captain To Make Ride With"></choose-captains-multi>
                    <div v-if="captain && !!captain.end_ride" class="red pa-2">
                        Has End Ride
                    </div>
                    <div v-if="captain && captain.first_ride" class="red pa-2">
                        First Ride Captain
                    </div>
                    <div v-else-if="captain && captain.first_day" class="orange pa-2">
                        First Day Captain
                    </div>

                    <v-flex xs12 class="mt-2 mb-2">
                        <v-select :items="dispatchTypeItems"
                                  v-model="dispatch_type"
                                  label="Select Dispatch Type"
                        />
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-end>
                            <v-btn :disabled="loading" flat large color="primary" @click="updateStepper">
                                Generate Ride
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-stepper-content>
            <v-stepper-content step="3">
                <v-card>
                    <v-card-title>
                        Saved And Generated Ride!
                    </v-card-title>
                </v-card>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import RequestsEditor from "@/components/RequestsEditor";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, RequestsEditor, ChooseCaptainsMulti},
        props: {
            selectedItems: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                step: 1,
                captain: null,
                loading: false,
                dispatch_type: null
            }
        },
        computed: {
            captainSearchParams() {
                const params = new URLSearchParams();
                params.append('service', this.selectedItems[0] && this.selectedItems[0].service_id);
                params.append('state', 'approved');
                return params;
            },
            dispatchTypeItems() {
                return [
                    {
                        text: "Let the system decide",
                        value: null
                    },
                    {
                        text: "Dispatch",
                        value: "DISPATCH"
                    },
                    {
                        text: "Suggest",
                        value: "SUGGEST"
                    }
                ]
            }
        },
        methods: {
            updateStepper() {
                if (this.step === 2) {
                    this.loading = true;
                    this.axios.post(this.api.ACTIONS.DISPATCH_BOOKINGS, {
                        bookings: this.selectedItems.map(item => item.id),
                        captain: this.captain.id,
                        service: this.selectedItems[0].service_id,
                        dispatch_type: this.dispatch_type
                    }).then(() => {
                        window.getApp.$emit('SHOW_TOAST', "RIDE CREATED!");
                        this.step++;
                        setTimeout(() => this.$emit("close"), 1500);
                    }).catch(error => {
                        window.getApp.$emit('SHOW_TOAST', error.response.data.message, 'red');
                        console.log(error);
                    }).finally(() => this.loading = false);
                } else
                    this.step++;
            }
        },
        name: "GenerateRide"
    }
</script>

<style scoped>

</style>